import React, { useEffect, useState } from "react";

import { getLocalStorageCountry, triggerLeaves, useNavigate, useTranslation } from "utils";

import { COUNTRY_CODE } from "consts";

import { Button, Svg, Trans } from "components";

import { ReferralBanner } from "pages/app/dashboard/components/ReferralBanner";

const LEAF_COUNT = 16;

export const CourseComplete = ({ course, referralToken, onClose }) => {
  const { t } = useTranslation("courses");
  const navigate = useNavigate();
  const country = getLocalStorageCountry();

  const [showReferralBanner] = useState(country !== COUNTRY_CODE.POLAND);

  useEffect(() => triggerLeaves(LEAF_COUNT), []);

  const handleGoToDashboard = () => {
    onClose();
    navigate("/dashboard");
  };

  return (
    <div className="course-complete-drawer">
      <section className="completed container tiny">
        <div className="center margin-bottom-200">
          <Svg svgName="misc/success_screen_checkmark" height={124} width={124} />
        </div>
        <h1 className="deep-black-text center margin-bottom-100">{t("courseComplete.completed")}</h1>
        <p className="explainer small center margin-bottom-250">
          <Trans i18nKey="courses:courseComplete.explainer" courseTitle={course.title}>
            <p>{{ courseTitle: course.title }}</p>
          </Trans>
        </p>
        {showReferralBanner && <ReferralBanner referralToken={referralToken} />}
        <div className="button-container">
          <Button type="primary" onClick={handleGoToDashboard}>
            {t("courseComplete.goToDashboard")}
          </Button>
          <Button onClick={onClose}>{t("courseComplete.backToCourse")}</Button>
        </div>
      </section>
    </div>
  );
};
